import axios from "axios";
import store from "../store/index";
import axiosUrl from "./axios.service";
import router from "../router/index";
import moment from "moment";
import EApplicationTerm from "../enums/EApplicationTerm";

const API_URL = axiosUrl.getAxiosUrl();

class SchemesServices {
  async getSearchResults(
    searchText,
    // statusBoxes,
    audiences,
    locations,
    germanLocationsPaths,
    //This is just hidden for now, don't remove it
    //industries,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsInclude,
    orgsExclude,
    startDate,
    endDate,
    page = 0,
    pageSize = 5000,
    schemeStatusGroup
  ) {
    return await axios
      .get(API_URL + "search/searchschemes", {
        params: {
          Term: searchText.value,
          PageSize: pageSize,
          Page: page,
          Sort: "Relevantie",
          // Statusses: statusBoxes.value,
          Statusses: schemeStatusGroup,
          AudienceTags: audiences.value,
          //This is just hidden for now, don't remove it
          //IndustriesTags: industries.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags:
            locations.value != null && locations.value.length > 0
              ? locations.value.join()
              : null,
          GermanLocationsTags:
            germanLocationsPaths.value != null &&
            germanLocationsPaths.value.length > 0
              ? germanLocationsPaths.value.join()
              : null,
          AppliesToSME: smeString.value,
          ApplicationTerms: applicationTermsString.value,
          MinAmount: minBudget.value != 0 ? minBudget.value : null,
          MaxAmount: maxBudget.value != 0 ? maxBudget.value : null,
          Scopes: scopesString.value,
          NotOrganisations:
            orgsExclude.value.length > 0 ? orgsExclude.value.join() : null,
          Organisations:
            orgsInclude.value.length > 0 ? orgsInclude.value.join() : null,
          CallStartDate:
            startDate.value != null &&
            startDate.value != "" &&
            startDate.value != '""'
              ? moment(startDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          CallEndDate:
            endDate.value != null &&
            endDate.value != "" &&
            endDate.value != '""'
              ? moment(endDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null
        }
      })
      .then(response => {
        store.commit("advancedSearch/updateCurrentPage", 1);
        store.commit("scheme/updateAllSchemes", response.data);
        store.commit("schemeItems/updateGrants", response.data);
        store.commit("advancedSearch/updatePageCount", response.data.pageCount);
        store.commit(
          "advancedSearch/updateResultsCount",
          response.data.resultCount
        );
        store.commit("scheme/updatePagination", response.data);
      })
      .catch(this.updateErrorModal);
  }

  async getResulstsByPage(
    current,
    searchText,
    //  statusBoxes,
    audiences,
    locations,
    germanLocationsPaths,
    //This is just hidden for now, don't remove it
    //industries,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsInclude,
    orgsExclude,
    startDate,
    endDate,
    page = 0,
    pageSize = 7,
    schemeStatusGroup
  ) {
    return await axios
      .get(API_URL + "search/searchschemes", {
        params: {
          Term: searchText.value,
          //Statusses: statusBoxes.value,
          Statusses: schemeStatusGroup,
          AudienceTags: audiences.value,
          //This is just hidden for now, don't remove it
          //IndustriesTags: industries.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags:
            locations.value != null && locations.value.length > 0
              ? locations.value.join()
              : null,
          GermanLocationsTags:
            germanLocationsPaths.value != null &&
            germanLocationsPaths.value.length > 0
              ? germanLocationsPaths.value.join()
              : null,
          AppliesToSME: smeString.value,
          ApplicationTerms: applicationTermsString.value,
          MinAmount: minBudget.value != 0 ? minBudget.value : null,
          MaxAmount: maxBudget.value != 0 ? maxBudget.value : null,
          Scopes: scopesString.value,
          Organisations: orgsInclude.value.join(),
          NotOrganisations: orgsExclude.value.join(),
          CallStartDate:
            startDate.value != null &&
            startDate.value != "" &&
            startDate.value != '""'
              ? moment(startDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          CallEndDate:
            endDate.value != null &&
            endDate.value != "" &&
            endDate.value != '""'
              ? moment(endDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          PageSize: pageSize,
          Page: page
        }
      })
      .then(response => {
        store.commit("schemeItems/updateGrants", response.data);
        store.commit(
          "advancedSearch/updatePageCount",
          response.data.pageCount + 1
        );
        store.commit(
          "advancedSearch/updateResultsCount",
          response.data.resultCount
        );
      })
      .catch(this.updateErrorModal);
  }

  async getSMETypes() {
    return await axios
      .get(API_URL + `schemes/getAllSMETypes`)
      .then(response => {
        store.commit("scheme/updateSME", response.data);
      })
      .catch(this.updateErrorModal);
  }

  getSchemeSDGThemeTypes() {
    return axios
      .get(API_URL + `schemes/getSchemeSDGThemeTypes`)
      .then(response => {
        store.commit("scheme/updateSDGThemeTypes", response.data);
      })
      .catch(this.updateErrorModal);
  }

  async getDocumentTypes() {
    return await axios
      .get(API_URL + `schemes/getDocumentTypes`)
      .then(response => {
        store.commit("scheme/updateDocumentTypes", response.data);
      })
      .catch(this.updateErrorModal);
  }

  async getSchemeCallsAndApplicationPeriods(
    schemeId,
    filterSearchTerm,
    sortBy,
    descending,
    page,
    pageSize
  ) {
    return await axios
      .get(API_URL + "schemes/getSchemeCallsAndApplicationPeriods", {
        params: {
          schemeId: schemeId,
          filterSearchTerm: filterSearchTerm,
          sortBy: sortBy,
          descending: descending,
          index: page ?? 0,
          size: pageSize ?? 20
        }
      })
      .then(response => {
        store.commit(
          "scheme/updateSchemeCallsAndApplicationPeriodsList",
          response.data.items
        );
        store.commit(
          "scheme/updateSchemeCallsAndApplicationPeriodsPagination",
          response.data
        );
      })
      .catch(this.updateErrorModal);
  }

  getScopes() {
    return axios
      .get(API_URL + `schemes/getAllScopes`)
      .then(response => {
        store.commit("scheme/updateScopes", response.data);
      })
      .catch(this.updateErrorModal);
  }

  async getTerms() {
    return await axios
      .get(API_URL + `schemes/getAllTerms`)
      .then(response => {
        store.commit("scheme/updateApplicationTerms", response.data);
      })
      .catch(this.updateErrorModal);
  }

  async getSchemeById(id) {
    return await axios
      .get(API_URL + "schemes/getScheme", {
        params: {
          schemeId: id
        }
      })
      .then(response => {
        store.commit("scheme/setSelectedScheme", response.data);
        if (response.data.groupTags != null) {
          const groupNames = response.data.groupTags.map(
            group => group.groupName
          );
          store.commit("tree/setLocationGroupsSelected", groupNames);
        }
      })
      .catch(this.updateErrorModal);
  }

  async getSchemeSelectedTags(schemeId, tagType, tagTypeValue) {
    return await axios
      .get(
        API_URL +
          `schemes/getSchemeSelectedTags?schemeId=${schemeId}&tagType=${tagTypeValue}`,
        {
          params: {
            culture: "nl"
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          var type = tagType.split(" ").join("");
          store.commit(
            "scheme/setSelectedScheme" + `${type}` + "Tags",
            response.data
          );
        }
      })
      .catch(this.updateErrorModal);
  }

  async createNewScheme(scheme, filesFormData) {
    const schemeUpdates = scheme.schemeUpdates.map(obj => {
      return {
        ...obj,
        updateDateTime: moment(obj.updateDateTime, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        )
      };
    });

    const schemeSME = store.state.scheme.createSchemeSmeString;
    return await axios({
      method: "post",
      url: API_URL + "schemes/createScheme",
      data: {
        Name: scheme.newName,
        Identifier: scheme.identifier,
        Introduction: scheme.newIntroduction,
        Body: scheme.newBody,
        Criteria: scheme.newCriteria,
        Budget: scheme.newBudget,
        SchemeStart:
          scheme.startDate != null && scheme.startDate != ""
            ? moment(scheme.startDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : null,
        SchemeEnd:
          scheme.endDate != null && scheme.endDate != ""
            ? moment(scheme.endDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : null,
        FundingOrganisations: scheme.selectedFundingOrgs,
        AdministratingOrganisations: scheme.selectedAdministratingOrgs,
        AdvisingOrganisations: scheme.selectedAdvisingOrgs,
        RecipientOrganisations: scheme.selectedRecipientOrgs,
        //   SMEType: scheme.selectedSME,
        SMEType: schemeSME,
        Scope: scheme.selectedScope,
        Status: scheme.status,
        PublicationStatus: scheme.publicationStatus,
        Accronym: scheme.newAccronym,
        Archivecode: scheme.newArchiveCode,
        ApplicationTerm:
          scheme.selectedApplicationTerm ?? EApplicationTerm.Undefined,
        Duration: scheme.newDuration,
        MinAmount: scheme.minAmount,
        MaxAmount: scheme.maxAmount,
        Exclusion: scheme.exclusion,
        FinancialInformation: scheme.financialInformation,
        ApplicationProcedure: scheme.applicationProcedure,
        PortalBody: scheme.portalBody,
        ComplexityRating: scheme.complexityRating,
        ChanceOfSuccessRating: scheme.chanceOfSuccessRating,
        TimeForApplicationRating: scheme.timeForApplicationRating,
        Links: scheme.schemeLinks,
        IsICTUScheme: scheme.ICTUscheme,
        MinimalAge: scheme.minimalAge,
        MaximalAge: scheme.maximalAge,
        SchemeUpdates: schemeUpdates,
        IsPortalScheme: scheme.isPortalScheme,
        IsAlwaysOpen: scheme.isAlwaysOpen,
        isScienceScheme: scheme.isScienceScheme,
        IsEnglishScheme: scheme.isEnglishScheme,
        HasEnglishCalls: scheme.hasEnglishCalls,
        IsOBScheme: scheme.schemeIsOBScheme,
        OBDescription: scheme.schemeOBDescription,
        OBTitle: scheme.schemeOBTitle,
        ApplicationInformation: scheme.applicationInformation,
        Tags: scheme.selectedTags.selectedAudiences
          .concat(scheme.selectedTags.selectedPurposes)
          .concat(scheme.selectedTags.selectedLocations)
          .concat(scheme.selectedTags.selectedSchemeTypes)
          .concat(scheme.selectedTags.selectedSchemeUserStatuses)
          .concat(scheme.selectedTags.selectedSchemeEducationLevels)
          .concat(scheme.selectedTags.selectedProjectTypes)
          .concat(scheme.selectedTags.selectedIndustriesNew),
        //This is just hidden for now, don't remove it
        //.concat(scheme.selectedTags.selectedIndustries)
        KeywordsTags: scheme.selectedTags.selectedSchemeKeywords,
        GroupsList: scheme.selectedGroups,
        LocationTags: scheme.locationTags
      }
    })
      .then(async response => {
        if (response.status == 200) {
          var newSchemeId = response.data.id;
          if (filesFormData != null) {
            filesFormData.append("schemeId", newSchemeId);
            await axios
              .post(API_URL + `schemes/uploadFile`, filesFormData)
              .then(response => {
                if (response.status == 200) {
                  router.push({
                    name: "EditScheme",
                    params: { id: newSchemeId }
                  });
                }
              })
              .catch((error) => this.updateErrorModal(error.response.data));

            store.commit("scheme/updateAreSchemeChangesLoading", false);
          } else {
            router.push({ name: "EditScheme", params: { id: newSchemeId } });
          }
        }
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async editScheme(scheme, autosave) {
    if (!autosave) {
      store.commit("scheme/updateAreSchemeChangesLoading", true);
    }

    const schemeUpdates = scheme.schemeUpdates && scheme.schemeUpdates.length > 0 ?
      scheme.schemeUpdates.map((obj) => {
      return {
        ...obj,
        updateDateTime: moment(obj.updateDateTime, "DD-MM-YYYY").format(
          "YYYY-MM-DD"
        )
      };
    }) : [];
    
    const updatedScheme = {
      Id: scheme.selectedSchemeId,
      ParentSchemeId: scheme.selectedSchemeParentSchemeId,
      Name: scheme.selectedSchemeName,
      Introduction: scheme.selectedSchemeIntroduction,
      SchemeStart:
        scheme.selectedSchemeStartDate == null ||
        scheme.selectedSchemeStartDate == ""
          ? null
          : moment(scheme.selectedSchemeStartDate, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            ),
      SchemeEnd:
        scheme.selectedSchemeEndDate == null ||
        scheme.selectedSchemeEndDate == ""
          ? null
          : moment(scheme.selectedSchemeEndDate, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            ),
      CallStart:
        scheme.selectedSchemeCallStartDate == null ||
        scheme.selectedSchemeCallStartDate == ""
          ? null
          : moment(scheme.selectedSchemeCallStartDate, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            ),
      CallEnd:
        scheme.selectedSchemeCallEndDate == null ||
        scheme.selectedSchemeCallEndDate == ""
          ? null
          : moment(scheme.selectedSchemeCallEndDate, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            ),
      Body: scheme.selectedSchemeBody,
      Criteria: scheme.selectedSchemeCriteria,
      Budget: scheme.selectedSchemeBudget,
      FundingOrganisations: scheme.selectedSchemeFundingOrgs,
      AdministratingOrganisations: scheme.selectedSchemeAdministratingOrgs,
      AdvisingOrganisations: scheme.selectedSchemeAdvisingOrgs,
      RecipientOrganisations: scheme.selectedSchemeRecipientOrgs,
      SchemeSDGThemes: scheme.selectedSchemeSDGThemes,
      GroupsList: scheme.locationGroupsSelected,
      SMEType: scheme.selectedSchemeSME,
      ApplicationTerm: scheme.selectedSchemeTerm ?? EApplicationTerm.Undefined,
      Scope: scheme.selectedSchemeScope,
      Archivecode: scheme.selectedSchemeArchivecode,
      Accronym: scheme.selectedSchemeAccronym,
      PublicationStatus: scheme.selectedSchemePublicationStatus,
      Status: scheme.selectedSchemeStatus,
      MinimalAge: scheme.selectedSchemeMinimalAge,
      MaximalAge: scheme.selectedSchemeMaximalAge,
      MinAmount: scheme.selectedSchemeMinAmount,
      MaxAmount: scheme.selectedSchemeMaxAmount,
      IsICTUScheme: scheme.selectedSchemeICTU,
      Exclusion: scheme.selectedSchemeExclusion,
      FinancialInformation: scheme.selectedSchemeFinancialInformation,
      ApplicationProcedure: scheme.selectedSchemeApplicationProcedure,
      PortalBody: scheme.selectedSchemePortalBody,
      ComplexityRating: scheme.selectedSchemeComplexityRating,
      ChanceOfSuccessRating: scheme.selectedSchemeChanceOfSuccessRating,
      TimeForApplicationRating: scheme.selectedSchemeTimeForApplicationRating,
      KeywordsTags: scheme.selectedSchemeKeywordsTags,
      IsCall: scheme.selectedSchemeIsCall,
      IsApplicationPeriod: scheme.selectedSchemeIsApplicationPeriod,
      IsPortalScheme: scheme.selectedSchemeIsPortal,
      IsAlwaysOpen: scheme.selectedSchemeIsAlwaysOpen,
      IsScienceScheme: scheme.selectedSchemeIsScience,
      IsEnglishScheme: scheme.selectedSchemeIsEnglish,
      HasEnglishCalls: scheme.selectedSchemeHasEnglishCalls,
      Duration: scheme.selectedSchemeDuration,
      Identifier: scheme.selectedSchemeIdentifier,
      Links: scheme.selectedSchemeLinks,
      IsOBScheme: scheme.selectedSchemeIsOBScheme,
      OBDescription: scheme.selectedSchemeOBDescription,
      OBTitle: scheme.selectedSchemeOBTitle,
      SchemeUpdates: schemeUpdates,
      ApplicationInformation: scheme.selectedSchemeApplicationInformation,
      RecurringStartingYear: scheme.selectedSchemeRecurringStartingYear,
      RecurringYearsDuration: scheme.selectedSchemeRecurringYearsDuration,
      RecurringStartDate: scheme.selectedSchemeRecurringStartDate
        ? moment(
            scheme.selectedSchemeRecurringStartDate,
            "DD-MM"
          ).format("YYYY-MM-DD")
        : null,
      RecurringEndDate: scheme.selectedSchemeRecurringEndDate
        ? moment(
            scheme.selectedSchemeRecurringEndDate,
            "DD-MM"
          ).format("YYYY-MM-DD")
        : null,
      HasRecurringDeadline: scheme.selectedSchemeHasRecurringDeadline,
      LocationTags: scheme.locationTagsSelectedIds,
      Tags: scheme.selectedSchemeAudienceTags
        .concat(scheme.selectedSchemePurposesTags)
        .concat(scheme.selectedSchemeLocationsTags)
        .concat(scheme.selectedSchemeSchemeTypesTags)
        .concat(scheme.selectedSchemeProjectTypesTags)
        .concat(scheme.selectedSchemeIndustriesNewTags)
        .concat(scheme.selectedSchemeUserStatusTags)
        .concat(scheme.selectedSchemeEducationLevelTags),
    };

    return await axios({
      method: "post",
      url: API_URL + `schemes/editScheme`,
      data: updatedScheme,
    })
      .then(response => {
        if (response.status == 200) {
          if (!autosave) {
            router.push({ name: "SchemesSearchPage" });
          }
        }
        store.commit("scheme/updateAreSchemeChangesLoading", false);
        sessionStorage.removeItem("schemeUpdatesToAdd");
      })
      .catch((error) => {
        if (autosave) {
          throw new Error(error.response.data);
        } else {
          store.commit("scheme/updateAreSchemeChangesLoading", false);
          this.updateErrorModal(error.response.data);
        }
      });
  }

  // used for the old q-uploader (when there was a need to upload multiple files at once)
  async uploadFile(formData, id) {
    return await axios
      .post(API_URL + `schemes/uploadFile`, formData)
      .then(response => {
        if (response.status == 200) {
          this.getSchemeDocuments(id);
        }
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async uploadSingleFile(formData, id) {
    return await axios
      .post(API_URL + `schemes/uploadSingleFile`, formData)
      .then(response => {
        if (response.status == 200) {
          this.getSchemeDocuments(id);
        }
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async removeDocument(id, documentId) {
    return await axios
      .post(API_URL + `schemes/removeDocument`, {
        id: id,
        document: {
          id: documentId
        }
      })
      .then(response => {
        if (response.status == 200) {
          this.getSchemeDocuments(id);
        }
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async updateDocument(schemeId, documentId, name, documentType) {
    return await axios
      .post(API_URL + `schemes/updateDocument`, {
        id: documentId,
        schemeId: schemeId,
        name: name,
        documentType: documentType
      })
      .then(response => {
        if (response.status == 200) {
          store.commit("scheme/refreshSchemeDocuments", response.data);
        }
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async downloadDocument(documentId) {
    return await axios
      .get(API_URL + `schemes/download?documentId=${documentId}`, {
        responseType: "blob",
        reportProgress: true
      })
      .catch((error) => this.updateErrorModal(error.response?.data));
  }

  async getPublicationStatuses() {
    return await axios
      .get(API_URL + "news/getPublicationStatuses")
      .then(response => {
        store.commit("scheme/updatePublicationStatuses", response.data);
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async createCall(call, filesFormData) {
    store.commit("scheme/updateAreSchemeChangesLoading", true);

    return await axios({
      method: "post",
      url: API_URL + "schemes/createCall",
      data: {
        Name: call.name,
        Identifier: call.identifier,
        Body: call.body,
        PublicationStatus: call.publicationStatus,
        Budget: call.budget,
        ParentSchemeId: call.parentId,
        IsCall: call.isCall,
        IsAlwaysOpen: call.isAlwaysOpen,
        CallStart:
          call.callStartDate != null && call.callStartDate != ""
            ? moment(call.callStartDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : null,
        CallEnd:
          call.callEndDate != null && call.CallEndDate != ""
            ? moment(call.callEndDate, "DD-MM-YYYY").format("YYYY-MM-DD")
            : null,
        Links: call.callLinks,
        Tags: call.selectedTags.selectedAudiences
          .concat(call.selectedTags.selectedPurposes)
          .concat(call.selectedTags.selectedLocations)
          .concat(call.selectedTags.selectedSchemeTypes)
          .concat(call.selectedTags.selectedIndustriesNew),
        KeywordsTags: call.selectedTags.selectedKeywords,
        InheritTags: call.inheritTags,
        RecurringStartingYear: call.recurringStartingYear,
        RecurringYearsDuration: call.recurringYearsDuration,
        RecurringStartDate: call.recurringStartDate
          ? moment(call.recurringStartDate, "DD-MM").format("YYYY-MM-DD")
          : null,
        RecurringEndDate: call.recurringEndDate
          ? moment(call.recurringEndDate, "DD-MM").format("YYYY-MM-DD")
          : null,
        HasRecurringDeadline: call.isRecurringDeadline,
        IsEnglishScheme: call.isEnglishScheme,
        LocationTags: call.locationTags
      }
    })
      .then(async response => {
        if (response.status === 200) {
          if (filesFormData != null) {
            filesFormData.append("schemeId", response.data.id);
            await axios
              .post(API_URL + `schemes/uploadFile`, filesFormData)
              .then(response => {
                if (response.status == 200) {
                  store.commit("scheme/enableSuccessfullyCreatedCallDialog");
                  this.getSchemeCallsAndApplicationPeriods(call.parentId);
                }
              })
              .catch((error) => this.updateErrorModal(error.response.data));
            store.commit("scheme/updateAreSchemeChangesLoading", false);
          } else {
            store.commit("scheme/updateAreSchemeChangesLoading", false);
            store.commit("scheme/enableSuccessfullyCreatedCallDialog");
            this.getSchemeCallsAndApplicationPeriods(call.parentId);
          }
        }
      })
      .catch(error => {
        store.commit("scheme/updateAreSchemeChangesLoading", false);
        this.updateErrorModal(error.response.data);
      });
  }

  async getSchemeDocuments(schemeId) {
    return await axios
      .get(API_URL + "schemes/getSchemeDocuments", {
        params: {
          schemeId: schemeId
        }
      })
      .then(response => {
        store.commit("scheme/refreshSchemeDocuments", response.data);
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async getSchemeUpdates(
    schemeId,
    filterSearchTerm,
    sortBy,
    descending,
    page,
    pageSize
  ) {
    return await axios
      .get(API_URL + "schemes/getSchemeUpdates", {
        params: {
          schemeId: schemeId,
          filterSearchTerm: filterSearchTerm,
          sortBy: sortBy,
          descending: descending,
          index: page ?? 0,
          size: pageSize ?? 20
        }
      })
      .then(response => {
        store.commit("scheme/updateSchemeUpdatesList", response.data.items);
        store.commit("scheme/updateSchemeUpdatesPagination", response.data);
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async deleteCallOrApplicationPeriod(itemId) {
    return await axios
      .post(API_URL + "schemes/deleteCallOrApplicationPeriod", {
        id: itemId
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async getSearchResultsSorted(
    searchText,
    audiences,
    locations,
    germanLocationsPaths,
    //This is just hidden for now, don't remove it
    //industries,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsInclude,
    orgsExclude,
    startDate,
    endDate,
    page = 0,
    pageSize = 5000,
    sortBy,
    descending,
    searchOnlyName,
    publicationStatusesString,
    filterByICTUFlag,
    durationPhrase,
    updatedDateGreaterThan,
    updatedDateLessThan,
    schemeStartGreaterThan,
    schemeStartLessThan,
    schemeEndGreaterThan,
    schemeEndLessThan,
    searchOnFundingOrgs,
    searchOnAdministratingOrgs,
    searchOnAdvisingOrgs,
    searchOnRecipientOrgs,
    isScienceScheme,
    isPortalScheme,
    isEnglishScheme,
    isObScheme,
    showAllLanguageVersions,
    schemeStatusesNew
  ) {
    return await axios
      .get(API_URL + "search/searchschemes", {
        params: {
          Term: searchText.value,
          DurationPhrase: durationPhrase.value,
          PageSize: pageSize,
          Page: page ? page - 1 : 0,
          Sort: sortBy != "" && sortBy != null ? sortBy : "Relevantie",
          SortAscending: !descending,
          // Sort: "Title",
          //   Statusses: statusBoxes.value, --remove com
          Statusses: schemeStatusesNew,
          AudienceTags: audiences.value,
          //This is just hidden for now, don't remove it
          //IndustriesTags: industries.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags:
            locations.value != null && locations.value.length > 0
              ? locations.value.join()
              : null,
          GermanLocationsTags:
            germanLocationsPaths.value != null &&
            germanLocationsPaths.value.length > 0
              ? germanLocationsPaths.value.join()
              : null,
          AppliesToSME: smeString.value,
          IsScienceScheme: isScienceScheme.value,
          IsPortalScheme: isPortalScheme.value,
          IsEnglishScheme: isEnglishScheme.value,
          IsObScheme: isObScheme.value,
          ApplicationTerms: applicationTermsString.value,
          PublicationStatus: publicationStatusesString,
          MinAmount: minBudget.value != 0 ? minBudget.value : null,
          MaxAmount: maxBudget.value != 0 ? maxBudget.value : null,
          Scopes: scopesString.value,
          NotOrganisations:
            orgsExclude.value && orgsExclude.value.length > 0
              ? orgsExclude.value.join()
              : null,
          Organisations:
            orgsInclude.value && orgsInclude.value.length > 0
              ? orgsInclude.value.join()
              : null,
          CallStartDate:
            startDate.value != null &&
            startDate.value != "" &&
            startDate.value != '""'
              ? moment(startDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          CallEndDate:
            endDate.value != null &&
            endDate.value != "" &&
            endDate.value != '""'
              ? moment(endDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          UpdatedDateLessThan:
            updatedDateLessThan.value != null && updatedDateLessThan.value != ""
              ? moment(updatedDateLessThan.value, "DD-MM-YYYY")
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss")
              : null,
          UpdatedDateGreaterThan:
            updatedDateGreaterThan.value != null &&
            updatedDateGreaterThan.value != ""
              ? moment(updatedDateGreaterThan.value, "DD-MM-YYYY")
                  .startOf("day")
                  .format("YYYY-MM-DD HH:mm:ss")
              : null,
          SchemeStartGreaterThan:
            schemeStartGreaterThan.value != null &&
            schemeStartGreaterThan.value != ""
              ? moment(schemeStartGreaterThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SchemeStartLessThan:
            schemeStartLessThan.value != null && schemeStartLessThan.value != ""
              ? moment(schemeStartLessThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SchemeEndGreaterThan:
            schemeEndGreaterThan.value != null &&
            schemeEndGreaterThan.value != ""
              ? moment(schemeEndGreaterThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SchemeEndLessThan:
            schemeEndLessThan.value != null && schemeEndLessThan.value != ""
              ? moment(schemeEndLessThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SearchOnlySchemeName: searchOnlyName.value,
          ShowIctuSchemes: filterByICTUFlag.value,
          SearchOnFundingOrganisations: searchOnFundingOrgs.value,
          SearchOnAdministratingOrganisations: searchOnAdministratingOrgs.value,
          SearchOnAdvisingOrganisations: searchOnAdvisingOrgs.value,
          SearchOnRecipientOrganisations: searchOnRecipientOrgs.value,
          ShowAllLanguageVersions: showAllLanguageVersions.value
        }
      })
      .then(response => {
        store.commit("advancedSearch/updateCurrentPage", 1);
        store.commit("scheme/updateAllSchemes", response.data);
        store.commit("schemeItems/updateGrants", response.data);
        store.commit("advancedSearch/updatePageCount", response.data.pageCount);
        store.commit(
          "advancedSearch/updateResultsCount",
          response.data.resultCount
        );
        store.commit("scheme/updatePagination", response.data);
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async copyScheme(schemeId, copyChildren) {
    return await axios
      .post(API_URL + "schemes/copyScheme", {
        id: schemeId,
        copyChildren: copyChildren
      })
      .then(response => {
        router.push({ name: "EditScheme", params: { id: response.data.id } });
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async copyCall(callId) {
    return await axios
      .post(API_URL + "schemes/copyCall", {
        id: callId
      })
      .then(response => {
        router.push({ name: "EditScheme", params: { id: response.data.id } });
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async getColorBasedOnVisualpingLinksStatuses(schemeId) {
    return await axios
      .get(API_URL + "schemes/getColorBasedOnVisualpingLinksStatuses", {
        params: {
          schemeId: schemeId
        }
      })
      .then(response => {
        store.commit("scheme/updateVisualpingColorForSelectedScheme", {
          schemeId: schemeId,
          color: response.data
        });
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async getSchemeVisualPingLinks(schemeId) {
    return await axios
      .get(API_URL + "schemes/getSchemeVisualPingLinks", {
        params: {
          schemeId: schemeId
        }
      })
      .then(response => {
        store.commit("scheme/updateSchemeVisualPingLinks", response.data);
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async getVisualPingLinkWithChanges(linkId) {
    return await axios
      .get(API_URL + "linkChecker/getvisualpinglinkwithchanges", {
        params: {
          linkid: linkId
        }
      })
      .then(response => {
        store.commit("scheme/updateVisualPingLinkWithChanges", response.data);
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async getFilteredSchemesForSelect(filter) {
    return await axios
      .get(API_URL + "schemes/getFilteredSchemesForSelect", {
        params: {
          filter: filter
        }
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async getParentSchemesForSelect(filter) {
    return await axios
      .get(API_URL + "schemes/getParentSchemesForSelect", {
        params: {
          filter: filter
        }
      })
      .then(response => response.data)
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async exportSchemes(
    searchText,
    audiences,
    locations,
    germanLocationsPaths,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsInclude,
    orgsExclude,
    startDate,
    endDate,
    page = 0,
    pageSize = 5000,
    sortBy,
    descending,
    searchOnlyName,
    publicationStatusesString,
    filterByICTUFlag,
    durationPhrase,
    updatedDateGreaterThan,
    updatedDateLessThan,
    schemeStartGreaterThan,
    schemeStartLessThan,
    schemeEndGreaterThan,
    schemeEndLessThan,
    searchOnFundingOrgs,
    searchOnAdministratingOrgs,
    searchOnAdvisingOrgs,
    searchOnRecipientOrgs,
    isScienceScheme,
    isPortalScheme,
    isEnglishScheme,
    isObScheme,
    showAllLanguageVersions,
    schemeStatusGroup
  ) {
    return await axios
      .get(API_URL + `schemes/exportSchemes`, {
        params: {
          Term: searchText,
          DurationPhrase: durationPhrase,
          PageSize: pageSize,
          Page: page ? page - 1 : 0,
          Sort: sortBy != "" && sortBy != null ? sortBy : "Relevantie",
          SortAscending: !descending,
          Statusses: schemeStatusGroup,
          AudienceTags: audiences.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags:
            locations.value != null && locations.value.length > 0
              ? locations.value.join()
              : null,
          GermanLocationsTags:
            germanLocationsPaths.value != null &&
            germanLocationsPaths.value.length > 0
              ? germanLocationsPaths.value.join()
              : null,
          AppliesToSME: smeString.value,
          ApplicationTerms: applicationTermsString.value,
          PublicationStatus: publicationStatusesString,
          MinAmount: minBudget.value,
          MaxAmount: maxBudget.value,
          Scopes: scopesString.value,
          NotOrganisations:
            orgsExclude.value.length > 0 ? orgsExclude.value.join() : null,
          Organisations:
            orgsInclude.value.length > 0 ? orgsInclude.value.join() : null,
          CallStartDate:
            startDate.value != null && startDate.value != ""
              ? moment(startDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          CallEndDate:
            endDate.value != null && endDate.value != ""
              ? moment(endDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          UpdatedDateLessThan:
            updatedDateLessThan.value != null && updatedDateLessThan.value != ""
              ? moment(updatedDateLessThan.value, "DD-MM-YYYY")
                  .endOf("day")
                  .format("YYYY-MM-DD HH:mm:ss")
              : null,
          UpdatedDateGreaterThan:
            updatedDateGreaterThan.value != null &&
            updatedDateGreaterThan.value != ""
              ? moment(updatedDateGreaterThan.value, "DD-MM-YYYY")
                  .startOf("day")
                  .format("YYYY-MM-DD HH:mm:ss")
              : null,
          SchemeStartGreaterThan:
            schemeStartGreaterThan.value != null &&
            schemeStartGreaterThan.value != ""
              ? moment(schemeStartGreaterThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SchemeStartLessThan:
            schemeStartLessThan.value != null && schemeStartLessThan.value != ""
              ? moment(schemeStartLessThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SchemeEndGreaterThan:
            schemeEndGreaterThan.value != null &&
            schemeEndGreaterThan.value != ""
              ? moment(schemeEndGreaterThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SchemeEndLessThan:
            schemeEndLessThan.value != null && schemeEndLessThan.value != ""
              ? moment(schemeEndLessThan.value, "DD-MM-YYYY").format(
                  "YYYY-MM-DD"
                )
              : null,
          SearchOnlySchemeName: searchOnlyName.value,
          ShowIctuSchemes: filterByICTUFlag.value,
          SearchOnFundingOrganisations: searchOnFundingOrgs.value,
          SearchOnAdministratingOrganisations: searchOnAdministratingOrgs.value,
          SearchOnAdvisingOrganisations: searchOnAdvisingOrgs.value,
          SearchOnRecipientOrganisations: searchOnRecipientOrgs.value,
          IsScienceScheme: isScienceScheme.value,
          IsPortalScheme: isPortalScheme.value,
          IsEnglishScheme: isEnglishScheme.value,
          IsObScheme: isObScheme.value,
          ShowAllLanguageVersions: showAllLanguageVersions.value
        },
        responseType: "blob",
        reportProgress: true
      })
      .catch((error) => this.updateErrorModal(error.response.data));
  }

  async searchLocationCodesBulk(query) {
    return await axios
      .get(API_URL + `locatioTag/searchLocationTagsBulk`, {
        params: {
          query: query
        }
      })
      .then(response => {
        store.commit("scheme/updateLocationTagsBulkList", response.data);
      });

    /*   async getLanguageCodes() {
    return await axios
      .get(API_URL + `users/getAllLanguageCodes`)
      .then((response) => {
        store.commit("scheme/updateLanguageCodes", response.data);
      })
      .catch((error) => {
        store.commit("news/updateModalError", error.response.data);
        store.commit("news/enableModalError");
})
  } */
  }

  async getSchemeStatuses() {
    return await axios
      .get(API_URL + `schemes/getSchemeStatuses`)
      .then(response => {
        store.commit("scheme/fillSchemeStatusOptions", response.data);
      })
      .catch(this.updateErrorModal);
  }

  updateErrorModal(error) {
    store.commit("scheme/updateModalError", error);
    store.commit("scheme/enableModalError");
  }
}

export default new SchemesServices();
